import { Accordion } from 'react-bootstrap'
import { FixitSVG } from 'src/components/Icons/Basic'
import { SectionTitle } from 'src/components/Reusable/Text/Text.styles'
import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const GapAccordion = styled(Accordion)`
  padding-top: 4px;
  padding-bottom: 4px;
  width: 100%;
`

export const GapAccordionItem = styled(Accordion.Item)<{
  $hoverable?: boolean
}>`
  border: none;
  transition: background-color 0.2s ease;

  && {
    border-radius: 16px;
  }

  .accordion-button,
  .accordion-body {
    background-color: transparent;
  }

  .accordion-button:not(.collapsed) {
    background-color: transparent;
  }

  ${({ $hoverable }) =>
    $hoverable &&
    `
    &:hover {
      background-color: ${palette.neutral[50]};
    }

    /* The header row carries an 8px bottom margin, which leaves its text
       riding high in the hover background. Split it evenly above and below
       so the row stays the same height but sits centered. */
    .accordion-button > :first-child {
      margin-top: 4px;
      margin-bottom: 4px;
    }
  `}
`

export const GapAccordionHeader = styled(Accordion.Header)<{
  $isActive?: boolean
}>`
  .accordion-button {
    font-size: 14px;
    color: ${palette.neutral[900]};
    padding: 0;

    :focus,
    :hover,
    :not(.collapsed) {
      outline: none;
      box-shadow: none;
    }

    &::after {
      display: none;
    }
    svg.control-check-chevron {
      transform: ${({ $isActive }) =>
        $isActive ? 'rotate(180deg)' : 'rotate(0deg)'};
      transition: transform 0.35s ease;
    }
  }
`

export const GapAccordionBody = styled(Accordion.Body)`
  padding: 0;
`

export const GapSectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  word-break: break-word;
`

export const GapObjectTitle = styled(SectionTitle).attrs({ $size: 14 })`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 8px;
  padding-left: 8px;
`

export const GapRemediationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 16px;
  border-radius: 12px;
  background-color: ${palette.neutral[30]};
  margin-top: 8px;
  margin-bottom: 8px;
`

export const GapRemediationItem = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const RemediationIcon = styled(FixitSVG)`
  height: 18px;
  width: 18px;
  background-color: ${palette.blue[300]};
  padding: 3px;
  border-radius: 4px;
`

export const GapObjectSection = styled.div`
  &:not(:last-child) {
    margin-bottom: 16px;
  }
`
